module.exports = __webpack_public_path__ + "static/img/wealth_level_94.1f00505.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_94.png
// module id = 7Dfq
// module chunks = 0